// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2plzt","paginator":"Pagination_paginator__3Lcgb","arrow":"Pagination_arrow__3na1i","middle":"Pagination_middle__2b9BJ"};